/** Stats sidebar periods and the matching main-toolbar titles. */
export const SAVINGS_PERIODS: { value: 'all' | '90d' | '30d'; label: string }[] = [
  { value: '30d', label: 'Last 30 Days' },
  { value: '90d', label: 'Last 90 Days' },
  { value: 'all', label: 'All Time' },
];

export function savingsPeriodLabel(period: string): string {
  return SAVINGS_PERIODS.find((candidate) => candidate.value === period)?.label ?? 'All Time';
}

/** Number of lookback days for the selected Savings period. */
export function savingsPeriodDays(period: 'all' | '90d' | '30d'): number {
  switch (period) {
    case 'all':
      return 0;
    case '90d':
      return 90;
    case '30d':
      return 30;
  }
}
